import React from 'react';

const NotificationSubTitle = (props) => {
	return (
		<h2 className="page-subtitle">EMAIL DIGEST</h2>
	);  
}

export default NotificationSubTitle;